import * as React from "react";
import { ArrowRight, Globe } from "lucide-react";
import { GradientButton } from "./gradient-button";
import { previewUrl, signUpUrl } from "@/lib/cta";

type Props = {
  align?: "left" | "center";
  buttonLabel?: string;
  primaryLabel?: string;
  showPrimary?: boolean;
  showForm?: boolean;
  /** Identifies the originating page for UTM tracking. */
  source?: string;
};

export function WebsiteCta({
  align = "left",
  buttonLabel = "See what Axy.digital can do for you",
  primaryLabel = "Get started for free",
  showPrimary = true,
  showForm = true,
  source = "website-cta",
}: Props) {
  const [url, setUrl] = React.useState("");
  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!url) return;
    window.location.href = previewUrl(url, source);
  };
  return (
    <div className={`flex flex-col gap-4 ${align === "center" ? "items-center" : "items-start"}`}>
      {showPrimary && (
        <GradientButton asChild>
          <a href={signUpUrl(source)}>
            {primaryLabel} <ArrowRight className="size-4" />
          </a>
        </GradientButton>
      )}
      {showForm && (
        <form
          onSubmit={onSubmit}
          className={`flex w-full max-w-xl items-center gap-2 rounded-full border border-white/15 bg-white/5 backdrop-blur-md p-1.5 pl-4 ${
            align === "center" ? "mx-auto" : ""
          }`}
        >
          <Globe className="size-4 text-white/50 shrink-0" />
          <input
            type="url"
            inputMode="url"
            placeholder="yourcompany.com"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            className="flex-1 bg-transparent text-sm text-white placeholder:text-white/40 outline-none py-2"
            aria-label="Your website URL"
          />
          <button
            type="submit"
            className="btn-gradient hover:-translate-y-px hover:brightness-110 transition-all rounded-full px-4 py-2 text-sm font-medium inline-flex items-center gap-2 whitespace-nowrap"
          >
            {buttonLabel} <ArrowRight className="size-4" />
          </button>
        </form>
      )}
    </div>
  );
}
